import { defineMessages } from 'react-intl';

export default defineMessages({
    noCoverage: {
        id: 'CPMIquoteandbind.bop.directives.bop-building-directive.No Coverages',
        defaultMessage: 'No Coverages'
    },
    noneSelected: {
        id: 'CPMIpolicycommon.directives.coverages.select.None Selected',
        defaultMessage: 'None Selected'
    },
    selectedValue: {
        id: 'CPMIpolicycommon.The value must be between',
        defaultMessage: 'The value must be between {minValue} and {maxValue}'
    },
    minValue: {
        id: 'CPMIpolicycommon.The minimum allowed value is',
        defaultMessage: 'The minimum allowed value is {minValue}'
    },
    maxValue: {
        id: 'CPMIpolicycommon.The maximum allowed value is',
        defaultMessage: 'The maximum allowed value is {maxValue}'
    },
    updatingSelection: {
        id: 'CPMIpolicycommon.directives.coverages.Updating selection...',
        defaultMessage: 'Updating selection...'
    }
});
